import mixpanel from 'mixpanel-browser'
import React from 'react'
import { optimizelyFeatureFlags } from 'src/constants/optimizely'
import initMixpanel from 'src/utils/initMixpanel'

import { MixPanelContext } from './constants'
import { useOptimizely } from './useOptimizely'


const MixpanelProvider = ({ children }: { children: React.ReactNode }) => {
  const newSalesJourneyDecision = useOptimizely('new-sales-journey')
  const newSalesJourney = newSalesJourneyDecision.variationKey ?? false

  const emberFunnelDecision = useOptimizely(optimizelyFeatureFlags.ENABLE_INSURANCE_EMBER_FUNNEL)
  const emberFunnelVariant = emberFunnelDecision.enabled ? 'variant' : 'control'

  initMixpanel()

  mixpanel.identify()

  // document is not available during server side rendering.
  if (typeof document !== 'undefined') {
    mixpanel.people.set({
      OptimizelySignUpVariant: newSalesJourney,
      OptimizelyEmberFunnelVariant: emberFunnelVariant,
    })
  }

  return <MixPanelContext.Provider value={mixpanel}>{children}</MixPanelContext.Provider>
}

export default MixpanelProvider
